<div class="h-full w-full flex flex-col justify-start overflow-hidden space-y-4">
  <app-admin-options-nav />

  <div class="flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden">
    <admin-stats-section-nav [items]="navItems" />
    <div class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <router-outlet />
    </div>
  </div>
</div>
